module.exports = __webpack_public_path__ + "static/ABCFavoritMono-Light-4e6b8854bcc85284f3cfec685864692c.woff";